import * as PIXI from "pixi.js";
import Tween from "tween.ts";
import Animation from "./Animation";


export default class WFireworkAnimation extends Animation {
  constructor(WFirework: PIXI.Container, y: number, onComp: () => void) {
    super()
    new Tween.Tween(WFirework)
      .to({
        y
      }, 700)
      .easing(Tween.Easing.Linear.None)
      .onComplete(() => onComp())
      .start()
  }
}